import { finalize } from 'rxjs/operators';
import MaskLoader from '../components/MaskLoader.vue';

let timeout;

export default function(Vue) {
  const LoaderComponent = Vue.extend(MaskLoader);
  Vue.prototype.$loader = new LoaderComponent({ propsData: { variant: 'primary' } });

  Vue.prototype.$loading = function loading(observable, callback) {
    const vm = this;

    if (!vm.$root.$el) {
      throw new Error('root element not initialized');
    }

    // eslint-disable-next-line no-underscore-dangle
    if (!vm.$loader._isMounted) {
      vm.$loader.$mount();
      vm.$root.$el.appendChild(vm.$loader.$el);
    }

    clearTimeout(timeout);
    vm.$loader.isLoading = true;

    const source = observable.pipe(
      finalize(() => {
        timeout = setTimeout(() => {
          vm.$loader.isLoading = false;
        }, 500);
      }),
    );

    vm.$subscribeTo(source, callback);
  };
}
